import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import regexp from 'shared/constants/regexp';
import { connect } from 'react-redux';
import { textErrField, notEmptyField } from 'shared/modules';
import cx from 'classnames';
import {
  beforeRegistration as setBeforeRegistration,
  userCheckCode,
  changePassword,
} from 'shared/actions/user';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import Button from 'shared/components/AntdComponents/Button/Button';
import Form from 'shared/components/AntdComponents/Form/Form';
import Input from 'shared/components/AntdComponents/Input/Input';

import s from './NewPassword.css';

const isMobile = __APP__ === 'mobile';
const FormItem = Form.Item;
class NewPassword extends Component {
  static propTypes = {
    form: PropTypes.shape({
      getFieldsValue: PropTypes.func,
      validateFieldsAndScroll: PropTypes.func,
      resetFields: PropTypes.func,
    }),
    action: PropTypes.shape({
      userAuthorize: PropTypes.func,
      logistics: PropTypes.func,
      loginWithFacebookToken: PropTypes.func,
    }),
    user: PropTypes.shape({ token: PropTypes.string }),
    intl: intlShape.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
    action: {},
    user: {},
    form: {},
    serverError: null,
    initialStart: false,
    checkCode: false,
  };

  state = {
    checkCode: false,
    initialStart: false,
  };

  componentWillUnmount() {
    this.props.dispatch(setBeforeRegistration());
  }
  handleChange(key, data) {
    const {
      action,
      form: { setFields },
      intl,
      user: {
        user: { email },
      },
    } = this.props;
    const fun = {
      checkCode: () => {
        this.setState({ checkCode: true }, () => {
          action.userCheckCode(
            {
              callback: () => {
                this.setState({ initialStart: false });
              },
              thing: email,
            },
            {
              nameFields: 'userPassword',
              setFields,
              intl,
            },
          );
        });
      },
      changePassword: () => {
        this.setState({ initialStart: true }, () => {
          this.props.form.validateFieldsAndScroll(null, { force: true }, (errors, values) => {
            if (errors) {
              return;
            }
            if (values.nexNewPassword !== values.newPassword) {
              setFields({
                nexNewPassword: {
                  value: values.nexNewPassword,
                  errors: [new Error(intl.formatMessage({ id: 'Пароли должны совпадать' }))],
                },
              });
            } else {
              action.changePassword(
                {
                  callback: () => {
                    this.setState({ initialStart: false, checkCode: false });
                  },

                  data: {
                    old_password: values.oldPassword,
                    new_password: values.newPassword,
                  },
                },
                {
                  setFields,
                  intl,
                },
              );
            }
          });
        });
      },
    };
    if (fun[key]) {
      fun[key](data);
    } else {
      console.error(key);
    }
  }
  render() {
    const {
      form: { getFieldDecorator },
      intl,
      user: { beforeRegistration: { exists, password_assigned: passwordAssigned } = {} },
    } = this.props;
    const { checkCode } = this.state;
    return (
      <div>
        {exists || passwordAssigned ? (
          <React.Fragment>
            {passwordAssigned ? (
              <FormItem>
                {getFieldDecorator('oldPassword', {
                  rules: [
                    {
                      validator: (rule, value, cb) => {
                        if (!this.state.initialStart || (value && regexp.password.test(value))) {
                          cb();
                        } else {
                          cb(
                            intl.formatMessage({
                              id: notEmptyField(value, 'Неверный старый пароль'),
                            }),
                          );
                        }
                      },
                    },
                  ],
                })(
                  <Input
                    type="password"
                    name="password"
                    className={isMobile ? s.inputMobile : s.input}
                    onPressEnter={() => this.handleChange('changePassword')}
                    placeholder={intl.formatMessage({
                      id: 'Введите старый пароль',
                    })}
                  />,
                )}
              </FormItem>
            ) : (
              ''
            )}

            <FormItem>
              {getFieldDecorator('newPassword', {
                rules: [
                  {
                    validator: (rule, value, cb) => {
                      if (
                        !this.state.initialStart ||
                        textErrField(value, null, {
                          password: true,
                          bool: true,
                        })
                      ) {
                        cb();
                      } else {
                        cb(
                          intl.formatMessage({
                            id: textErrField(value, 'Некорректный пароль', {
                              password: true,
                            }),
                          }),
                        );
                      }
                    },
                  },
                ],
              })(
                <Input
                  type="password"
                  name="password"
                  className={isMobile ? s.inputMobile : s.input}
                  onPressEnter={() => this.handleChange('changePassword')}
                  placeholder={intl.formatMessage({
                    id: 'Введите новый пароль',
                  })}
                />,
              )}
            </FormItem>

            <FormItem>
              {getFieldDecorator('nexNewPassword', {
                rules: [
                  {
                    validator: (rule, value, cb) => {
                      if (value) {
                        cb();
                      } else {
                        cb(
                          intl.formatMessage({
                            id: notEmptyField(value, ''),
                          }),
                        );
                      }
                    },
                  },
                ],
              })(
                <Input
                  type="password"
                  name="password"
                  className={isMobile ? s.inputMobile : s.input}
                  onPressEnter={() => this.handleChange('changePassword')}
                  placeholder={intl.formatMessage({
                    id: 'Повторите новый пароль',
                  })}
                />,
              )}
            </FormItem>
            <div className={cx({ [s.passwordText]: !isMobile })}>
              <FormattedMessage id="Пароль должен содержать не менее восьми символов, включать буквы и цифры" />
            </div>
          </React.Fragment>
        ) : (
          ''
        )}

        <Button
          className={cx({ [s.passwordBtn]: !isMobile, [s.passwordBtnMobile]: isMobile })}
          onClick={() => this.handleChange(checkCode ? 'changePassword' : 'checkCode')}
        >
          <FormattedMessage id="Изменить пароль" />
        </Button>
      </div>
    );
  }
}

export default withStyles(s)(
  connect(
    ({ loading: { start }, user }) => ({
      loading: Boolean(start),
      user,
    }),
    dispatch => ({
      action: bindActionCreators(
        {
          userCheckCode,
          changePassword,
        },
        dispatch,
      ),
      dispatch,
      setBeforeRegistration,
    }),
  )(Form.create()(injectIntl(NewPassword))),
);



// WEBPACK FOOTER //
// ./src/shared/components/NewPassword/NewPassword.js